import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import * as Yup from 'yup'
import cn from 'classnames'
import { Formik, Form, Field } from 'formik'
import { isEmpty, last } from 'lodash'
import { useHistory, useParams } from 'react-router'

import Modal from 'components/Modal'
import { SpySidebar } from 'components/SpySidebar.js'
import TagsBox from 'components/TagsBox'
import CustomErrorMessage from 'components/CustomErrorMessage'

import { sendReceipt } from 'utils/api'
import Loader from 'components/Loader'

const SendReceipt = ({ order, isLoading }) => {
  const [showValidationErrors, setShowValidationErrors] = useState(false)

  const positiveAmountPaymentInfo = order?.paymentInfo?.filter(
    (info) => info.amountInCents > 0
  )
  const lastPaymentInfo = last(positiveAmountPaymentInfo)
  const paymentUuid = lastPaymentInfo?.uuid

  const history = useHistory()
  const { uuid } = useParams()
  const emailRegexp = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/

  const initialValues = {
    emailAddress: [],
  }

  const validationSchema = Yup.object().shape({
    emailAddress: Yup.array()
      .of(Yup.string().matches(emailRegexp, 'Invalid Email Address'))
      .min(1, 'Required')
      .required('Required'),
  })

  const onCloseModal = () => {
    history.push('/orders')
  }
  const onClickReturn = () => {
    history.goBack()
  }

  const onClickSaveButton = () => {
    setShowValidationErrors(true)
  }

  const disableUpdateButton = useCallback(
    (errors) => {
      const disableButton = showValidationErrors && !isEmpty(errors)

      return disableButton
    },
    [showValidationErrors]
  )

  const onSubmit = ({ emailAddress }) => {
    sendReceipt(uuid, emailAddress, paymentUuid).then(() => history.goBack())
  }

  return (
    <Modal
      title="Send Receipt"
      isReturnIcon
      onClickReturn={onClickReturn}
      onClose={onCloseModal}
    >
      {isLoading ? (
        <Loader />
      ) : (
        <div className="modal-body">
          <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            validateOnChange
          >
            {({ errors, setFieldValue, isSubmitting }) => (
              <Form className="item-settings">
                <section>
                  <div className="content-wrapper">
                    <Field
                      component={TagsBox}
                      name="emailAddress"
                      placeholder="Email Address"
                      handleValueChange={(tagsValues) => {
                        setFieldValue('emailAddress', tagsValues)
                      }}
                      className={cn({ '-error': showValidationErrors })}
                      showValidationErrors={showValidationErrors}
                      error={errors?.emailAddress}
                    />
                  </div>
                  {showValidationErrors && errors && (
                    <CustomErrorMessage
                      name="emailAddress"
                      showValidationErrors={showValidationErrors}
                      info={errors?.emailAddress ?? ''}
                    />
                  )}
                  <p className="description">
                    Separate multiple emails with comma
                  </p>
                </section>
                <div className="btn-wrapper">
                  <button
                    className="btn -update"
                    onClick={onClickSaveButton}
                    disabled={disableUpdateButton(errors) || isSubmitting}
                    type="submit"
                  >
                    Send
                  </button>
                </div>
              </Form>
            )}
          </Formik>
          <SpySidebar settings={[{ text: 'Details', ref: null }]} />
        </div>
      )}
    </Modal>
  )
}

SendReceipt.propTypes = {
  order: PropTypes.object,
  isLoading: PropTypes.bool,
}

export default SendReceipt
